import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

interface ReviewQueueStatusProps {
  loading: boolean;
  error: unknown;
  onRetry: () => void;
  label: string;
}

/**
 * Shared loading/error state for the deferred unreviewed review queues.
 * Renders nothing once the queue has loaded successfully.
 */
export default function ReviewQueueStatus({
  loading,
  error,
  onRetry,
  label,
}: ReviewQueueStatusProps) {
  if (!loading && !error) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={180}
      p={4}
    >
      {loading ? (
        <>
          <CircularProgress size={32} />
          <Box mt={2}>
            <Typography color="textSecondary">Loading {label}…</Typography>
          </Box>
        </>
      ) : (
        <>
          <Typography color="error">Could not load {label}.</Typography>
          <Box mt={2}>
            <Button variant="outlined" color="primary" onClick={onRetry}>
              Try again
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}
